import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            backgroundColor: "white",
            padding: "15px 20px 8px 0px",
            marginTop: "20px",
            marginRight: "30px",
            boxShadow: "0px 2px 10px rgba(110, 102, 102, 0.2)",
            borderRadius: "0px",
            position: "relative",
        },
        sku: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#270ADC",
        },
        highlightedText: {
            fontSize: "18px",
            fontWeight: 600,
        },
        text: {
            fontWeight: 500,
            marginBottom: "5px",
        },
        selected: {
            cursor: "auto",
            backgroundColor: "#F8F8F8",
        },
        disabled: {
            overflow: "auto",
            backgroundColor: "rgba(255, 255, 255, 1)",
            zIndex: theme.zIndex.appBar - 1,
            color: "rgba(24, 24, 24, 0.6)",
        },
        icon: {
            padding: "0px",
            marginLeft: "30px",
        },
        gridItem: {
            padding: "10px 0px 10px 0px",
            minWidth: "150px",
            textAlign: "center",
        },
        btn: {
            paddingTop: "12px",
            paddingBottom: "10px",
            marginRight: "20px",
            borderRadius: "4px",
            float: "right",
        },
        approveBtn: {
            backgroundColor: "rgba(0, 175, 65, 1)",
            "&:hover": {
                backgroundColor: "rgba(0, 175, 65, 1)",
            },
        },
        reviewBtn: {
            backgroundColor: "white",
            color: "#270ADC",
            border: "1px solid #270ADC",
            "&:hover": {
                border: "1px solid #270ADC",
                backgroundColor: "#270ADC",
                color: "white",
            },
        },
        minimizeBtn: {
            backgroundColor: "white",
            color: "#270ADC",
            border: "1px solid #270ADC",
            "&:hover": {
                border: "1px solid #270ADC",
                backgroundColor: "#270ADC",
                color: "white",
            },
        },
        notReviewedBtn: {
            border: "1px solid rgba(255, 171, 0, 1)",
            backgroundColor: "white",
            color: "rgba(255, 171, 0, 1)",
            "&:hover": {
                color: "black",
                backgroundColor: "rgba(255, 171, 0, 1)",
                border: "1px solid rgba(255, 171, 0, 1)",
            },
        },
        quantityEditButton: {
            position: "absolute",
            marginTop: "-2px",
            cursor: "pointer",
        },
        quantityPopup: {
            marginTop: "-2px",
            marginLeft: "-12px",
        },
        quantityMainPaper: { padding: "10px", display: "flex" },
        quantityInput: { width: "20px", border: "none" },
        quantitySubmitButton: { cursor: "pointer", marginLeft: "5px" },
    })
);
